import { kebabCase } from "lodash";
import { put, takeEvery } from "redux-saga/effects";

import { BUSINESS_REGISTRATION } from "constants/actionTypes";

import { deserializeBusinessRegistration } from "lib/serializers/businessRegistrations";
import toast from "lib/toast";

import { api } from "sagas/api";

const REQUERY_TOAST = "Re-Checking ABN Status";

type RegistrationRequestAction = {
  type: string;
  payload: { id?: string; abn?: string; acn?: string };
  options?: {
    onSuccess?: (registration: BusinessRegistration) => void;
    onError?: (errors: Record<string, string[]> | null) => void;
  };
};

function* storeRegistration(response) {
  yield put({ type: BUSINESS_REGISTRATION.FETCH.SUCCESS, payload: response });
  return deserializeBusinessRegistration(response);
}

function notifyError(action: RegistrationRequestAction, error) {
  action.options?.onError?.(error?.errors || null);
}

export function* lookupRegistration(payload: { abn?: string; acn?: string }) {
  const response = yield api.post(
    "/v2/business-registrations/lookup/",
    payload,
  );
  return yield storeRegistration(response);
}

function* onLookupBusinessRegistration(action: RegistrationRequestAction) {
  const { abn, acn } = action.payload;
  try {
    const registration = yield lookupRegistration({ abn, acn });
    action.options?.onSuccess?.(registration);
  } catch (error) {
    notifyError(action, error);
  }
}

function* onRequeryBusinessRegistration(action: RegistrationRequestAction) {
  const { id } = action.payload;
  toast.syncing(REQUERY_TOAST, { autoClose: false });
  try {
    const response = yield api.post(
      `/v2/business-registrations/${id}/requery-abn/`,
      {},
    );
    const registration = yield storeRegistration(response);
    toast.dismiss(kebabCase(REQUERY_TOAST));
    toast.success("ABN Status Synced");
    action.options?.onSuccess?.(registration);
  } catch (error) {
    toast.dismiss(kebabCase(REQUERY_TOAST));
    toast.error(`An error occurred re-checking the ABN. ${error.message}`);
    notifyError(action, error);
  }
}

export default function* businessRegistrationsSaga() {
  yield takeEvery(
    BUSINESS_REGISTRATION.LOOKUP.REQUEST,
    onLookupBusinessRegistration,
  );
  yield takeEvery(
    BUSINESS_REGISTRATION.REQUERY.REQUEST,
    onRequeryBusinessRegistration,
  );
}
